import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './main/_components/login/login.component';
import { RootModule } from './root/root.module';
import { PageNotFoundComponent } from './main/_components/page-not-found/page-not-found.component';
import { DashboardComponent } from './main/_components/dashboard/dashboard.component';
import { SharedModule, HttpLoaderFactory } from './shared/shared.module';
import { AlertComponent } from './main/_components/alert/alert.component';
import { ErrorsHandler } from './main/_utils/errors-handler';
import { LogoutComponent } from './main/_components/logout/logout.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from './main/_components/register/register.component';
import { ActivateComponent } from './main/_components/activate/activate.component';
import { TestSchedulerComponent } from './test-scheduler/test-scheduler.component';
import { FullCalendarModule } from '@fullcalendar/angular';

registerLocaleData(localeIt)

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		PageNotFoundComponent,
		DashboardComponent,
		AlertComponent,
		LogoutComponent,
		RegisterComponent,
		ActivateComponent,
		TestSchedulerComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		RootModule,
		SharedModule,
		BrowserAnimationsModule,
		FullCalendarModule
	],
	providers: [
		{ provide: ErrorHandler, useClass: ErrorsHandler },
		{ provide: LOCALE_ID, useValue: "it-IT" }
	],
	bootstrap: [AppComponent],
	exports: []
})
export class AppModule { }
